import { render, staticRenderFns } from "./AgentDelete.vue?vue&type=template&id=147d31e9&"
import script from "./AgentDelete.vue?vue&type=script&lang=js&"
export * from "./AgentDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports